// 基础资料-供应商列表
export const search = {
  inputs: [
    // 信息列数不多，故不要筛选项区域
  ],
  lines: [
    {
      prop: 'code',
      label: 'Supplier ID',
      width: 120
    },
    {
      prop: 'name',
      label: 'Supplier Name',
      width: 300
    },
    {
      prop: 'primary_person_first',
      label: 'First Name',
      width: 120
    },
    {
      prop: 'primary_person_last',
      label: 'Last Name',
      width: 120
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 130
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 130
    },
    {
      prop: 'guid',
      label: 'Xero GUID'
    }
    // 供应商资料不需要点击详情进行查看操作，因为信息量少。
  ]
}
// 不提供编辑页面、新增页面。供应商一旦新建，编辑的几率几乎没有。新增则暂时在数据库中操作
export default { search }
